// ═══════════════════════════════════════════════════════════════
// TODO LIST VIEW - Constants & Options
// ═══════════════════════════════════════════════════════════════

export const TODO_VIEW_MODES = {
  MASTER: 'master',     // Full nested hierarchy with sticky parents
  SIMPLE: 'simple',     // Current campaign only, no drilling into nested
  SWIMLANE: 'swimlane', // Grouped by status/priority/tag
};

export const SORT_OPTIONS = [
  { id: 'manual', label: 'Manual' },
  { id: 'status', label: 'Status' },
  { id: 'priority', label: 'Priority' },
  { id: 'dueDate', label: 'Due Date' },
  { id: 'name', label: 'Name' },
];

export const SWIMLANE_GROUP_OPTIONS = [
  { id: 'status', label: 'Status' },
  { id: 'priority', label: 'Priority' },
  { id: 'tag', label: 'Primary Tag' },
];

export const FILTER_OPTIONS = [
  { id: 'all', label: 'All' },
  { id: 'actionable', label: 'Actionable Only', hint: 'Tasks you can work on now' },
  { id: 'incomplete', label: 'Incomplete' },
  { id: 'complete', label: 'Complete' },
  { id: 'high-priority', label: 'High Priority' },
  { id: 'has-due-date', label: 'Has Due Date' },
  { id: 'overdue', label: 'Overdue' },
];
